import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewState } from 'app/models/app';
import { CompanyDto, ExternalJobDto, MatchedLeadsProductDto, ProposalDto } from 'app/models/dtos';
import { PermissionGroupsLookup } from 'app/models/lookups';
import { PermissionsService } from 'app/services/permissions/permissions.service';
import { environment } from 'environments/environment';
import { GenericBreadcrumb } from '../../common/generic-breadcrumbs/genericBreadcrumb';

@Component({
  selector: 'app-proposal-job',
  templateUrl: './proposal-job.component.html',
  // styleUrls: ['./proposal-job.component.css']
})
export class ProposalJobComponent implements OnInit {
  constructor(private http: HttpClient, private route: ActivatedRoute, private titleService: Title, private _router: Router, public permissionsService: PermissionsService) { }

  public id: string = '0';
  public productId: string = '0';
  public proposalId: string = '0';
  public jobId: string = '0';
  proposal: ProposalDto;
  company: CompanyDto;
  product: MatchedLeadsProductDto;
  job: ExternalJobDto;
  breadcrumbs(): GenericBreadcrumb[] {
    return [
      new GenericBreadcrumb(`${this.company?.name ?? 'Company'}`, `/companies/${this.id}`),
      new GenericBreadcrumb(`${this.product?.name ?? 'Product'}`, `/companies/${this.id}/matchedLeadsProducts/${this.productId}`),
      new GenericBreadcrumb(`${this.product?.name ?? 'Proposal'}`, `/companies/${this.id}/matchedLeadsProducts/${this.productId}/proposals/${this.proposalId}`)
    ];
  }

  //view states
  viewStates = ViewState;
  viewState = ViewState.loading;

  async ngOnInit() {
    //update title
    this.titleService.setTitle('Proposal | Admin');

    //parse query params
    this.id = this.route.snapshot.paramMap.get('id') ?? '0';
    this.productId = this.route.snapshot.paramMap.get('productId') ?? '0';
    this.proposalId = this.route.snapshot.paramMap.get('proposalId') ?? '0';
    this.jobId = this.route.snapshot.paramMap.get('jobId') ?? '0';

    await this.permissionsService.setContent(PermissionGroupsLookup.COMPANY, this.id);
    this.getCompany();
  }

  //api
  getCompany(): void {
    this.http
      .get(`${environment.services_tdusa_admin}/v1/companies/${this.id}`)
      .subscribe((result: CompanyDto) => {
        this.company = result;
        this.getProduct();
      });
  }

  getProduct(): void {
    this.http
      .get(`${environment.services_tdusa_admin}/v1/companies/${this.company.id}/matchedLeadsProducts/${this.productId}`)
      .subscribe((result: MatchedLeadsProductDto) => {
        this.product = result;
        this.getProposal();
      });
  }

  getProposal(): void {
    this.http
      .get(`${environment.services_tdusa_admin}/v1/companies/${this.company.id}/matchedLeadsProducts/${this.productId}/proposals/${this.proposalId}`)
      .subscribe((result: ProposalDto) => {
        this.proposal = result;
        this.getJob();
      });
  }

  getJob(): void {
    this.viewState = ViewState.loading;

    this.http
      .get(`${environment.services_tdusa_admin}/v1/companies/${this.company.id}/matchedLeadsProducts/${this.productId}/proposals/${this.proposalId}/jobs/${this.jobId}`)
      .subscribe((result: ExternalJobDto) => {
        this.job = result;
        this.viewState = ViewState.content;

        //update title
        this.titleService.setTitle(`${this.job.title ?? 'Proposal Job'} | Admin`);
      });
  }
}
